module.exports = __webpack_public_path__ + "img/feature_buy_id.6281918f.png";